import { FC } from 'react';

import { BottomSheet } from '../../../BottomSheet';
import { Modal, ModalCloseProps } from '../../../Modal';
import { useMedia } from '../../../useMedia';
import { DIALOG_DESKTOP_QUERY } from '../query';

export type ResponsiveDialogCloseProps = ModalCloseProps;

/** Modal.Close на десктопе, BottomSheet.Close на мобайле. */
const ResponsiveDialogClose: FC<ResponsiveDialogCloseProps> = (props) => {
  const isDesktop = useMedia(DIALOG_DESKTOP_QUERY);

  return isDesktop ? <Modal.Close {...props} /> : <BottomSheet.Close {...props} />;
};

export default ResponsiveDialogClose;
